
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.File = (function () {

    function File () {

        Monet.UI.Fields.TextField.apply(this, arguments);

        this.types = [];
        this.maxFileLength;

        this.validateExtension = function(file) {
            return (file &&
                    this.types.length &&
                    !file.name.match( new RegExp("^.*\.(" + this.types.join("|") + ")") ));
        };

        this.validateSize = function(file) {
            return ( file && this.maxFileLength && file.size > this.maxFileLength );
        };

        this.dataIsInvalid = function () {
            var file = this.getFile();
            var validated = this.validateExtension(file);
            validated = this.validateSize(file);
            return validated;
        };

        this.getFile = function() {
            return this.hiddenInput.files[0];
        };

        this.populateFakeInput = function() {
            var file = this.getFile();
            this.input.value = file.name;
        }.bind(this);

        this.createInputFile = function() {

            this.hiddenInput = document.createElement('input');
            this.hiddenInput.type = 'file';
            this.hiddenInput.style.display = "none";
            this.hiddenInput.addEventListener("change", this.populateFakeInput);

            this.input.addEventListener("click", function() {
                this.hiddenInput.click();
            }.bind(this));

            this.rootEl.appendChild(this.hiddenInput);

        };

        this.createElement = function () {

            this.input = document.createElement('input');
            this.rootEl.className += ' textField';
            this.input.setAttribute("readonly", "readonly");

            if(this.maxSize){
                this.input.maxLength = this.maxSize;
            }

            this.rootEl.appendChild(this.input);

            this.createInputFile();

        };

    }

    return File;

}());